import React from "react";

const Arrow: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.16683 10.8333H13.4752L9.4085 14.9C9.0835 15.225 9.0835 15.7583 9.4085 16.0833C9.7335 16.4083 10.2585 16.4083 10.5835 16.0833L16.0752 10.5917C16.4002 10.2667 16.4002 9.74166 16.0752 9.41666L10.5918 3.91666C10.2668 3.59166 9.74183 3.59166 9.41683 3.91666C9.09183 4.24166 9.09183 4.76666 9.41683 5.09166L13.4752 9.16666H4.16683C3.7085 9.16666 3.3335 9.54166 3.3335 10C3.3335 10.4583 3.7085 10.8333 4.16683 10.8333Z"
      fill="#66d1ff"
    />
  </svg>
);

export const TryProduct: React.FC = () => {
  return <Arrow />;
};
